export default "__VITE_ASSET__BUNQiMdI__"